import { useQuery } from "@tanstack/react-query";
import { GET } from "../../../../services/index";
import { message } from "antd";

/**
 * รายงาน pickup time รายคน
 *
 * ⚠️ หน้ารายงานห้าม subscribe realtime และห้ามตั้ง refetchInterval สั้น ๆ
 *    (เคยมีหน้า history ที่ subscribe แล้วยิง 30,636 request ใน 105 นาที)
 *    หน้านี้ยิงเมื่อกดปุ่มค้นหาเท่านั้น
 */
export const usePickupTimeReport = ({ from, to, enabled = false }) => {
  return useQuery(
    ["pickupTimeReport", from, to],
    async () => {
      try {
        const { result } = await GET(
          `/api/v1/pickupTimeReport?from=${from}&to=${to}`
        );
        return result;
      } catch (error) {
        await message.destroy();
        message.error(
          error?.response?.data?.message || "ไม่สามารถโหลดรายงาน Pickup Time ได้"
        );
        throw error;
      }
    },
    {
      enabled,
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    }
  );
};
